<template>
    <all-topics type="subscription" />
</template>

<script>
import AllTopics from './All'

export default {
    components: { AllTopics },
    name: 'Subscription',
}
</script>
